
import axios from 'axios'
import { ElMessage } from 'element-plus';
import {getBrowserInfo} from '@/utils/index'
// 引入 FingerprintJS
//import FingerprintJS from '@fingerprintjs/fingerprintjs';
import CryptoJS from 'crypto-js';
let browser=getBrowserInfo();//浏览器
//创建axios实例,后续所有通过实例发送的请求，都要受当前配置约束
const $http=axios.create({
    baseURL: 'https://sso.chinaecono.com',//'https://sso.chinaecono.com',//'/api1',//'https://8.131.245.178:36700',
    withCredentials: true, // 允许跨域携带Cookie
    headers: {
      'Content-Type': 'application/json',
      'X-Request-Source': 'WebApp',
      'X-Client-Version': '1.0.0'
    }
})
//添加请求拦截器
$http.interceptors.request.use(async function(config){
    //在发送请求之前做些什么，如token
    // 生成请求ID
    const requestId = generateRequestId()
    config.headers['X-Request-ID'] = requestId
    config.headers['X-Request-Timestamp'] = Date.now()
    

    
    // 对于敏感请求，添加令牌
    if (isSensitiveRequest(config.url)) {
      // // 确保令牌有效
      // let res_token= await generateToken()
      // console.log('res_token', res_token)
      // if (res_token.code==20000 && res_token.data) {
      //   config.headers['X-Request-Fingerprint'] = res_token.data.clientFingerprint//客户端指纹
      //   config.headers['X-Request-Token'] = res_token.data.token
      // }
      // console.log('config', config.data)
      // 生成请求签名
      if (config.data && typeof config.data === 'object') {
        let nonce=generateNonce()
        const signature = generateRequestSignature(config.data,nonce, config.headers['X-Request-Timestamp'])
        config.headers['X-Request-Signature'] = signature
        config.headers['X-Request-Nonce'] = nonce
      }
    }
    
    // 记录请求日志（开发环境）
    // if (import.meta.env.DEV) {
    //     console.log(`[Request] ${config.method.toUpperCase()} ${config.url}`, {
    //     headers: config.headers,
    //     data: config.data
    //   })
    // }
    return config;
},function(error){
    //对请求错误做些什么
    return Promise.reject(error);
})
//添加相应拦截器
$http.interceptors.response.use(res=>{   
  if(!res)
  {
    ElMessage.success({
      message: '服务器错误！', 
    });   
    return; 
  } 
  else
  {
    return res.data;
  } 
},err=>{  
  ElMessage.success({
    message: '请重新登录'+err, 
  });   
  return ;
}) 
// 生成请求ID
function generateRequestId() {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`
}

// 生成请求签名
function generateRequestSignature(data,nonce, timestamp) {
  const secretKey =  'signature_econo2025'
  
  // 排序参数
  const sortedData = sortObject(data)
  const signStr = `${timestamp}${nonce}${JSON.stringify(sortedData)}`
  return CryptoJS.HmacSHA256(signStr, secretKey).toString(CryptoJS.enc.Hex)
}

// 排序对象（用于签名）
function sortObject(obj) {
  if (obj === null || typeof obj !== 'object') return obj
  
  if (Array.isArray(obj)) {
    return obj.map(sortObject)
  }
  
  const sorted = {}
  Object.keys(obj).sort().forEach(key => {
    sorted[key] = sortObject(obj[key])
  })
  
  return sorted
}

// 生成随机nonce
function generateNonce() {
  return Math.random().toString(36).substring(2, 15) + 
         Math.random().toString(36).substring(2, 15)
}

// 判断是否为敏感请求
function isSensitiveRequest(url) {
  const sensitivePaths = [
    '/api/Account/SendVerifyCode'
  ]
  
  return sensitivePaths.some(path => url.includes(path))
}
//登录
export const login=(data)=>{
  data.ip=localStorage.getItem("ip");
  data.browserName=browser[1]+' '+browser[2];
  data.deviceType=browser[0].replace(';','');
  return $http.post(`/api/Account/Login`,data);
}
//刷新token
export const refreshToken=(data)=>{
    return $http.post('/api/Account/RefreshToken',data);
}
//滑块生成
export const generateCaptcha=(deviceId)=>{
  return $http.get('/api/Account/GenerateCaptcha?deviceId='+deviceId);
}
//滑块验证
export const verifyCaptch=(data)=>{
  return $http.post('/api/Account/VerifyCaptch',data);
}
//发送验证码
export const sendVerifyCode=(data)=>{
  return $http.post(`/api/Account/SendVerifyCode`,data);
}
//退出
export const loginOut=(data)=>{
  return $http.post(`/api/Account/LoginOut`,data);
}


